<div class="container" *transloco="let t" id="page_register">
  <mat-card class="p-0">
    <app-dynamic-image [mode]="'FLEX'">
      <div class="flex-container">
        <div
          class="flexBoxOuter pageId_Register bannerFlexBox bannerModeFlex ng-star-inserted"
          style="align-items: center"
        >
          <div class="flexBoxInner img marginRight bannerTextBox" style="display: flex; align-self: flex-end">
            <h1 class="bannerTitle" style="white-space: nowrap" data-translate="register.title">
              {{ t("register.title") }}
            </h1>
          </div>
        </div>
        <div class="flexBoxInner txt" style="display: inline-block; height: 30px; align-self: flex-end"></div>
      </div>
    </app-dynamic-image>
  </mat-card>

  <mat-card class="p-0 kv-mat-card">
    <!-- sectionId_register -->
    <app-prices [showBuildingCosts]="true"></app-prices>
  </mat-card>
</div>
